import type { ApiClient } from '../apiClient';

/**
 * Senior recording links — the "Dorothy flow" from the account holder's side.
 * An advisor (or a family member) generates a one-tap recording link; the owner
 * APPROVES it here (it is inert until they do); recordings the senior submits
 * land as pending-review drafts the owner sees here.
 */

export interface SeniorLink {
  token_id: string;
  pre_set_label: string | null;
  expires_at: string;
  created_at: string;
  approved: boolean;
  revoked: boolean;
  max_recordings: number;
  recording_count: number;
}

export interface AwaitingRecording {
  message_id: string;
  pre_set_label: string | null;
  duration_seconds: number | null;
  submitted_at: string;
}

export interface SeniorRecordingsView {
  links: SeniorLink[];
  awaiting_review: AwaitingRecording[];
}

export function listSeniorRecordings(
  api: ApiClient,
  vaultId: string,
): Promise<SeniorRecordingsView> {
  return api.get<SeniorRecordingsView>(`/api/vaults/${vaultId}/senior-recordings`);
}

export function approveSeniorLink(
  api: ApiClient,
  vaultId: string,
  tokenId: string,
): Promise<{ approvedAt: string }> {
  return api.post<{ approvedAt: string }>(
    `/api/vaults/${vaultId}/senior-tokens/${tokenId}/approve`,
    {},
  );
}
